var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.4971 2 12.9 2.40294 12.9 2.9V13.8272L13.7272 13C14.0787 12.6485 14.6485 12.6485 15 13C15.3515 13.3515 15.3515 13.9213 15 14.2728L12.6364 16.6364C12.2849 16.9879 11.7151 16.9879 11.3636 16.6364L5.26361 10.5364C4.91214 10.1849 4.91214 9.61508 5.26361 9.26361C5.61508 8.91214 6.18493 8.91214 6.5364 9.26361L11.1 13.8272V2.9C11.1 2.40294 11.5029 2 12 2ZM4 20C4 19.5029 4.40294 19.1 4.9 19.1H19.1C19.5971 19.1 20 19.5029 20 20C20 20.4971 19.5971 20.9 19.1 20.9H4.9C4.40294 20.9 4 20.4971 4 20Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3C16.2386 3 14 5.23858 14 8C14 10.7614 16.2386 13 19 13C21.7614 13 24 10.7614 24 8C24 5.23858 21.7614 3 19 3ZM21.7803 6.21967C21.4874 5.92678 21.0126 5.92678 20.7197 6.21967L18.25 8.68934L17.2803 7.71967C16.9874 7.42678 16.5126 7.42678 16.2197 7.71967C15.9268 8.01256 15.9268 8.48744 16.2197 8.78033L17.7197 10.2803C18.0126 10.5732 18.4874 10.5732 18.7803 10.2803L21.7803 7.28033C22.0732 6.98744 22.0732 6.51256 21.7803 6.21967Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCheckOutline);
export default __webpack_public_path__ + "static/media/download_check_outline.7182e5708e06f47f3400de67456a724c.svg";
export { ForwardRef as ReactComponent };